import { Card } from '@components/atoms/Card';
import { Button } from '@components/atoms/Button';
import { Modal } from '@components/molecules/Modal';
import { ConfirmationModal } from '@components/molecules/ConfirmationModal';
import { useState } from 'react';
import { SliderModal } from '@components/molecules/SlideOver';

export const ModalGroup = () => {
  const [isSliderModalOpen, setIsSliderModalOpen] = useState(false);
  const [isActionButtonsModalOpen, setIsActionButtonsModalOpen] =
    useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <Card>
      <div className="flex gap-2">
        <Button
          variant="primary"
          onClick={() => {
            setIsSliderModalOpen(true);
          }}>
          Slider modal
        </Button>
        <Button
          onClick={() => {
            setIsActionButtonsModalOpen(true);
          }}>
          Action Modal
        </Button>
        <Button
          onClick={() => {
            setIsConfirmationModalOpen(true);
          }}>
          Confirmation Modal
        </Button>
        <Button
          onClick={() => {
            setIsDeleteModalOpen(true);
          }}>
          Delete Confirmation Modal
        </Button>
      </div>
      <SliderModal
        confirmText="Save"
        cancelText="Cancel"
        title="Slider Modal"
        isOpen={isSliderModalOpen}
        closeSlider={() => setIsSliderModalOpen(false)}
        handleSubmit={() => {
          setIsSliderModalOpen(false);
        }}>
        <div>Slider Modal</div>
      </SliderModal>

      {/* action buttons modal */}
      <Modal
        cancelText="Cancel"
        confirmText="Confirm"
        title="Action Buttons Modal"
        isOpen={isActionButtonsModalOpen}
        onClose={() => setIsActionButtonsModalOpen(false)}
        handleConfirm={() => {
          setIsActionButtonsModalOpen(false);
        }}>
        <div className="text-gray-900 dark:text-white">Content</div>
      </Modal>

      {/* confirmation modal */}
      <ConfirmationModal
        variant="info"
        cancelText="Cancel"
        confirmText="Proceed"
        description="Are you sure you want to proceed with this action? This action cannot be undone."
        isOpen={isConfirmationModalOpen}
        onClose={() => setIsConfirmationModalOpen(false)}
        title="Confirm Action"
        onConfirm={() => {
          setIsConfirmationModalOpen(false);
        }}
      />

      {/* delete modal */}
      <ConfirmationModal
        variant="danger"
        title="Delete Item"
        cancelText="Cancel"
        confirmText="Delete"
        isOpen={isDeleteModalOpen}
        description="Are you sure you want to delete this item? This action cannot be undone and the item will be permanently removed."
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={() => {
          setIsDeleteModalOpen(false);
        }}
      />
    </Card>
  );
};
